<template>
  <div>
    <div class="que-search">
      <label>题目：</label> <input v-model="que_name" />
      <label>难度：</label>
      <select v-model="difficulty">
        <option value=""></option>
        <option value="0">入门</option>
        <option value="10">简单</option>
        <option value="20">中等</option>
        <option value="30">困难</option>
      </select>
      <label>标签：</label> <input v-model="que_tags" />
      <label>解答：</label>
        <select v-model="contain_answer">
          <option value=""></option>
          <option value="true">有</option>
          <option value="false">无</option>
        </select>
      <span class="search-span" @click="searchClick">搜索</span>
      <span class="search-span" @click="routesTopic">新增</span>
    </div>
    <div class="que-title">
      <div class="que-id">序号</div>
      <div class="que-name">题目</div>
      <div class="use-num">用例数</div>
      <div class="que-difficulty">难度</div>
      <div class="pass_rate">通过率</div>
      <div class="students_count">挑战人数</div>
    </div>
    <div v-for="(item,i) in quesInfo.records" :key="item">
      <queBar
          :id="i+1 + (curpage - 1) * pagesize"
          :que-info="item"
          @event-search="eventSearch" ></queBar>
    </div>
    <navBar
        :total="quesInfo.total"
        :curpage="curpage"
        :pagesize="pagesize"
        :navsize="navsize"
        @event-page-click="eventPageClick"></navBar>
 </div>
</template>

<script>
import serviceApi from "@/utils/serviceApi";
import queBar from "@/components/page/Bar/queBar";
import navBar from "@/components/panel/navBar";
import utils from "@/utils/utils";
import cookies from 'vue-cookies';

export default {
  name: "homeView",
  data(){
    return{
      que_name: '',
      que_tags: '',
      difficulty: '',
      contain_answer: '',
      navsize: 10,
      curpage: 1,
      pagesize: 20,
      quesInfo:{
        total: 0,
        records:[]
      }
    }
  },
  mounted() {
    this.que_name = utils.searchParam.que_name;
    this.que_tags = utils.searchParam.que_tags;
    this.difficulty = utils.searchParam.difficulty;
    this.contain_answer = utils.searchParam.contain_answer;
    this.curpage = utils.searchParam.curpage;
    this.pagesize = utils.searchParam.pagesize;
    serviceApi.loadAllQue(
        {
            que_name: this.que_name,
            que_tags: this.que_tags,
            difficulty: this.difficulty,
            contain_answer: this.contain_answer,
            curpage: this.curpage,
            pagesize: this.pagesize,
        },
        this.callback)
  },
  methods:{
    routesTopic: function (){
      if (cookies.get('guid') != null && cookies.get('guid') == "0849c42f236f7cb046a06d41832f1723"){
        this.$router.push({
            name:'topicView',
            query:{
              gid: utils.guid()
            }
        });
      }
    },
    callback: function (resultData){
      this.quesInfo.total = resultData.total;
      this.quesInfo.records = resultData.rows
    },
    eventSearch: function (tags){
      this.que_tags = tags;
      this.searchClick()
    },
    searchClick: function (){
        this.curpage = 1;
        let Params = {
            que_name: this.que_name,
            que_tags: this.que_tags,
            difficulty: this.difficulty,
            contain_answer: this.contain_answer,
            curpage: this.curpage,
            pagesize: this.pagesize,
            }
        utils.searchParam = JSON.parse(JSON.stringify(Params));
        serviceApi.loadAllQue(
          Params,
          this.callback);
    },
    eventPageClick: function (pageno){
      if(pageno > 0 &&
          pageno <= Math.ceil(this.quesInfo.total / this.pagesize)){
        this.curpage = pageno;
        let Params = {
            que_name: this.que_name,
            que_tags: this.que_tags,
            difficulty: this.difficulty,
            contain_answer: this.contain_answer,
            curpage: this.curpage,
            pagesize: this.pagesize,
            }
        utils.searchParam = JSON.parse(JSON.stringify(Params));
        serviceApi.loadAllQue(
          Params,
          this.callback);
      }
    }
  },
  components:{
    queBar,
    navBar
  }
}
</script>

<style scoped>
.que-search{
  white-space:nowrap;
  overflow: hidden;
  height: 50px;
  line-height: 50px;
  border-bottom: 1px solid #eee;
}
.que-search input{
 width: 100px;
}
.que-search select{
 width: 100px;
}
.que-search label{
  margin-left: 20px;
  font-weight: bold;
}
.que-title{
  height: 50px;
  background-color: #eeefff;
  border-bottom: 1px solid #eee;
  line-height: 50px;
  font-size: 16px;
  white-space:nowrap;
  overflow: hidden;
}
.que-id{
  width: 8%;
  max-width: 80px;
  display: inline-block;
  text-align: center;
}
.que-name{
  width: 32%;
  max-width: 400px;
  display: inline-block;
}
.use-num{
  width: 10%;
  max-width: 100px;
  display: inline-block;
}

.que-difficulty{
  width: 10%;
  max-width: 100px;
  display: inline-block;
}
.pass_rate{
  width: 10%;
  max-width: 100px;
  display: inline-block;
}
.students_count{
  width: 20%;
  max-width: 200px;
  display: inline-block;
}
.que-search .search-span{

  display: inline-block;
  border-radius: 5px;
  height: 26px;
  line-height: 26px;
  margin-left: 50px;
  margin-top: 8px;
  margin-right: 5px;
  padding-left: 10px;
  padding-right: 10px;
  cursor: pointer;
  border: 1px solid #eee;
}

.que-search .search-span:hover{
  border: 1px solid #2e7eee;
  background-color: #2e7eee;
  color: #fff;
}

</style>
